(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/voucher-handler.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/voucher-handler.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const logger = svs.core.log.getLogger('components:game-handler');
const getThemeGame = (games, skinId) => {
  let themeToUse = null;
  const themeGame = games.find(game => {
    var _game$themes;
    return game.isThemeable && ((_game$themes = game.themes) === null || _game$themes === void 0 ? void 0 : _game$themes.find(_ref => {
      let {
        themeName
      } = _ref;
      return themeName.toLowerCase() === skinId;
    }));
  });
  if (themeGame) {
    themeGame.themes.forEach(theme => {
      if (theme.themeName.toLowerCase() === skinId) {
        themeToUse = theme;
      }
    });
    const variations = themeToUse.skins.length;
    return _objectSpread(_objectSpread({}, themeGame), {}, {
      theme: themeToUse.themeName,
      skins: themeToUse.skins,
      variations,
      normalizeSkinId: skinId => skinId > 0 && skinId <= variations ? skinId : 1
    });
  }
  return games.find(game => game.theme.toLowerCase() === skinId);
};
setGlobal('svs.ticketgames.gameHandler.chooseGameForVoucher', function (voucher) {
  let disableEqualPrizedGame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (svs.utils.ns.isNamespace('svs.ticketgames.gameHandler.games')) {
    var _voucher$skinId;
    const {
      games
    } = svs.ticketgames.gameHandler;
    const skinId = (_voucher$skinId = voucher.skinId) === null || _voucher$skinId === void 0 ? void 0 : _voucher$skinId.toString().toLowerCase();
    const applicableGames = games.filter(game => Number(game.voucherId) === Number(voucher.voucherConfigId) && game.open && game.activeForRedeem).sort((a, b) => (a.claimableAs.indexOf(a.type) + 1 || Infinity) - (b.claimableAs.indexOf(b.type) + 1 || Infinity));
    const themeGame = getThemeGame(applicableGames, skinId);
    const equalPrizeGame = games.find(game => parseInt(voucher.value, 10) === parseInt(game.price, 10) && game.open && game.activeForRedeem);
    return themeGame || applicableGames[0] || (disableEqualPrizedGame ? equalPrizeGame : undefined);
  }
  logger.error('No ticket games found');
  return undefined;
});

 })(window);